<template lang="pug">
  v-layout(row)
    v-flex(xs12 sm6 offset-sm3)
      v-card
        v-toolbar(color="white" flat)
          v-toolbar-title(class="grey--text text--darken-4") Create an item
        v-form
          v-container
            
            v-text-field(v-model="itemName" label="Item Name") 
            v-text-field(v-model="cost" label="Cost") 

            combobox(:items="cats" @setModel="setCategory" label="Category")
            v-textarea(
              name="description"
              v-model="description"
              label="Description"
              hint="Sell the concept of the item")
            image-upload
            v-btn(@click="save") Save

</template>
<script>
//Creates an item 


const ImageUpload  = () => import('../../components/ImageUpload')
const Combobox = () => import('../../components/Combobox')
export default {
  name: 'CreateItem',
  components: {ImageUpload, Combobox},
  data: () => ({
    description:'' ,
    category:'',
    cost:'',
    itemName:''
  }),

  computed:{
    cats(){
      return this.$store.state.categories
    }
  },
  methods:{
    setCategory(val){
      this.category = val
    },
    save(){
      let item = {
        itemName: this.itemName,
        description: this.description,
        imageURL: this.$store.state.imageURL,
        cost: this.cost,
        category: this.category
      }
      this.$store.dispatch('saveItem', item)
    },
  }

}
</script>


